import { AutoMap } from "@automapper/classes";

export class LastUsedConsommableEntity {

    Id?: number;
    TypeOfService!: number;
    @AutoMap()
    Type!: number
    @AutoMap()
    NumeroLot!: string
    @AutoMap()
    Expiration!: string
}